import React, { useEffect, useState } from "react";
import { FormViewType } from "../Tickets/Tickets";
import { StorageItems } from "../../../utils/storageItems";
import { DataSelectType } from "../../../models/DataSelectType";
import { AssetInterface } from "../../../models/AssetModel/Asset";
import { useDarkModeStore } from "../../../store/useDarkModeStore";
import { darkModeBackgroud, PAGESIZE } from "../../../utils/constants";
import Skeleton from "react-loading-skeleton";
import AssetCard from "./Components/AssetCard";
import TableViewForm from "./AssetViews/TableViewForm";
import CardHeader from "./Components/Header/CardHeader";
import ToastMessage from "../../../common/ToastMessage";
import useAssets from "../../../store/ReactQueries/assets/asset/useAsset";
import FilterAssetComponent from "./Components/Filter/FilterAssetComponent";

export const Assets = () => {
  const { darkMode } = useDarkModeStore();

  const storageFormView = localStorage.getItem(StorageItems.AssetView) as FormViewType | null;
  const storedPage = localStorage.getItem(StorageItems.AssetPage);
  const storedPageSize = localStorage.getItem(StorageItems.AssetPageSize);

  const [page, setPage] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(PAGESIZE);
  const [formView, setFormView] = useState<FormViewType>(storageFormView ?? "TableView");
  const [loading, setLoading] = useState<boolean>(false);
  const [selectedIds, setSelectedIds] = useState<string[]>([]);
  const [showFilters, setShowFilters] = useState<boolean>(false);
  const [filterData, setFilterData] = useState<DataSelectType[]>();
  const initialState: AssetInterface = {
    id: "",
    barcode: "",
    assetCategoryId: "",
    title: "",
    assetTypeId: "",
    description: "",
    assetDepartmentId: "",
    assetStatusId: "",
    price: 0,
    companyId: "",
    customerId: "",
    locationId: "",
    vendorId: "",
    warrantyDate: undefined,
    boughtDate: undefined,
    invoiceNo: "",
  };
  const [form, setForm] = useState<AssetInterface>(initialState);

  const { data: assets, error, isLoading } = useAssets(page, pageSize, filterData);

  localStorage.setItem(StorageItems.AssetPage, page.toString());
  localStorage.setItem(StorageItems.AssetPageSize, pageSize.toString());

  useEffect(() => {
    if (error) ToastMessage.Failed(error.message);
  }, [error]);

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      const previousLocation = localStorage.getItem("PreviousLocation");
      const isNotAssetPath = !["/assets/", "/asset/"].some((path) => previousLocation?.includes(path));
      if (previousLocation === "") {
        setPage(storedPage ? parseInt(storedPage) : 1);
        setPageSize(storedPageSize ? parseInt(storedPageSize) : 20);
      } else if (isNotAssetPath) {
        setPage(1);
        setPageSize(PAGESIZE);
      } else {
        setPage(storedPage ? parseInt(storedPage) : 1);
        setPageSize(storedPageSize ? parseInt(storedPageSize) : 20);
      }
    }, 100);

    const timer = setTimeout(() => {
      setLoading(false);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  return formView === "CardView" ? (
    <div className="mb-4">
      <CardHeader
        page={page}
        module="Assets"
        pageSize={pageSize}
        formView={formView}
        selectedIds={selectedIds}
        showFilters={showFilters}
        arrayLength={assets?.length ?? 0}
        setPage={setPage}
        setPageSize={setPageSize}
        setFormView={setFormView}
        setSelectedIds={setSelectedIds}
        setShowFilters={setShowFilters}
      />
      <div className={`d-flex flex-row transition-wrapper ${!showFilters && "gap-0"}`}>
        <div className={`content ${showFilters ? "shrink" : ""}`}>
          {assets?.map((asset) =>
            loading ? (
              <div
                className="card d-flex flex-row align-items-center gap-2 p-3 card-assets position-relative card-feedback"
                style={{ height: 107 }}
                key={asset.id}
              >
                <Skeleton style={{ width: 20, height: 20 }} />
                <Skeleton style={{ borderRadius: 8, width: 50, height: 50 }} />
                <div className="d-flex flex-column gap-1">
                  <Skeleton style={{ width: 40, height: 18 }} />
                  <Skeleton style={{ width: 150, height: 18 }} />
                  <Skeleton style={{ width: 300, height: 18 }} />
                </div>
                <div className="ms-auto d-flex flex-column gap-1 me-5">
                  <Skeleton style={{ width: 120, height: 14 }} />
                  <Skeleton style={{ width: 120, height: 14 }} />
                  <Skeleton style={{ width: 120, height: 14 }} />
                </div>
              </div>
            ) : (
              <AssetCard
                key={asset.id}
                page={page}
                asset={asset}
                pageSize={pageSize}
                selectedIds={selectedIds}
                setSelectedIds={setSelectedIds}
              />
            ),
          )}
        </div>
        <div
          className={`filter-section ${showFilters ? "expand" : ""}`}
          style={{
            border: showFilters ? "1px solid rgba(224, 224, 224, 1)" : "none",
            background: darkMode ? darkModeBackgroud : "white",
          }}
        >
          {showFilters && (
            <FilterAssetComponent
              page={page}
              pageSize={pageSize}
              filterData={filterData}
              showFilters={showFilters}
              setPage={setPage}
              setFilterData={setFilterData}
            />
          )}
        </div>
      </div>
    </div>
  ) : (
    <TableViewForm
      page={page}
      form={form}
      pageSize={pageSize}
      formView={formView}
      filterData={filterData}
      showFilters={showFilters}
      setForm={setForm}
      setPage={setPage}
      setPageSize={setPageSize}
      setFormView={setFormView}
      setFilterData={setFilterData}
      setShowFilters={setShowFilters}
    />
  );
};
export default Assets;
